import { Phone, MapPin, Clock } from "lucide-react";
import { clinicConfig } from "@/config/clinic";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="border-t border-border bg-secondary">
      <div className="mx-auto max-w-7xl px-6 py-16 md:px-12">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-12">
          <div className="md:col-span-5">
            <a href="#top" className="flex items-center gap-3">
              <img src="/logo-teal.png" alt="" className="h-10 w-10 object-contain dark:hidden" />
              <img src="/logo-cream.png" alt="" className="hidden h-10 w-10 object-contain dark:block" />
              <span className="font-serif text-xl font-semibold text-foreground">{clinicConfig.name}</span>
            </a>
            <p className="mt-5 max-w-sm text-base leading-relaxed text-muted-foreground">
              {clinicConfig.tagline} Established, local family medicine with
              virtual access through Doc Talk.
            </p>
            <a
              href={clinicConfig.patientPortalUrl}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-signin-cta"
              className="mt-6 inline-flex rounded-full bg-primary px-6 py-3 text-sm font-semibold text-primary-foreground transition-colors hover:bg-primary/90"
            >
              Patient Sign In
            </a>
          </div>

          <div className="md:col-span-4">
            <p className="text-xs font-bold uppercase tracking-[0.22em] text-muted-foreground">Contact</p>
            <ul className="mt-5 space-y-4 text-base text-foreground/80">
              <li className="flex items-start gap-3">
                <MapPin className="mt-0.5 h-5 w-5 flex-none text-accent" strokeWidth={1.5} />
                <a href={clinicConfig.mapUrl} target="_blank" rel="noopener noreferrer" className="hover:text-foreground">
                  {clinicConfig.address}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="h-5 w-5 flex-none text-accent" strokeWidth={1.5} />
                <a href={`tel:${clinicConfig.phoneTel}`} className="hover:text-foreground">
                  {clinicConfig.phoneDisplay}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Clock className="h-5 w-5 flex-none text-accent" strokeWidth={1.5} />
                Mon–Thu, 9 a.m.–5 p.m. ET
              </li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="text-xs font-bold uppercase tracking-[0.22em] text-muted-foreground">Practice</p>
            <ul className="mt-5 space-y-3 text-base text-foreground/80">
              <li><a href="#care" className="hover:text-foreground">Care Options</a></li>
              <li><a href="#doctor" className="hover:text-foreground">The Doctor</a></li>
              <li><a href="#visit" className="hover:text-foreground">Visit Us</a></li>
              <li><a href="#faq" className="hover:text-foreground">FAQ</a></li>
              <li>
                <a href={clinicConfig.patientPortalUrl} target="_blank" rel="noopener noreferrer" className="hover:text-foreground">
                  Doc Talk Portal
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 flex flex-col gap-4 border-t border-border pt-8 text-sm text-muted-foreground md:flex-row md:items-center md:justify-between">
          <p>© {new Date().getFullYear()} {clinicConfig.name}. All rights reserved.</p>
          <div className="flex flex-wrap gap-x-6 gap-y-2">
            <a href={clinicConfig.patientPortalUrl} target="_blank" rel="noopener noreferrer" className="hover:text-foreground">Privacy Practices</a>
            <a href={clinicConfig.patientPortalUrl} target="_blank" rel="noopener noreferrer" className="hover:text-foreground">Terms of Use</a>
            <a href={clinicConfig.patientPortalUrl} target="_blank" rel="noopener noreferrer" className="hover:text-foreground">Non-Discrimination</a>
            <a href={clinicConfig.patientPortalUrl} target="_blank" rel="noopener noreferrer" className="hover:text-foreground">Accessibility</a>
          </div>
        </div>
        <p className="mt-6 text-xs leading-relaxed text-muted-foreground/80">
          This website is for general information and does not provide medical
          advice. For medical emergencies, call 911. Doc Talk offers
          message-based care with clinician responses typically within 24 hours.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
